import { render, staticRenderFns } from "./MemoramInstance.vue?vue&type=template&id=0b5288b6&scoped=true&"
import script from "./MemoramInstance.vue?vue&type=script&lang=js&"
export * from "./MemoramInstance.vue?vue&type=script&lang=js&"
import style0 from "./MemoramInstance.vue?vue&type=style&index=0&id=0b5288b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5288b6",
  null
  
)

export default component.exports